import axiosApi from "../api/axiosInstance";

// fetch customerDetails
export async function getMosqueOrders() {
  try {
    // If server expects cookie auth: include credentials
    const resp = await axiosApi.get("/api/v2/customer/mosqueorders");

    // console.log(resp);

    if (resp.data && resp.data.success) return resp.data;
    throw new Error("Unexpected response: " + JSON.stringify(resp.data));
  } catch (err) {
    // console.error("fetchCustomerDetails error", err);
    throw err;
  }
}

export const uploadFileToServer = async (formData) => {
  const url = "/api/v2/customer/loyaltycard/upload";

  const response = await axiosApi.post(url, formData, {
    withCredentials: true,
    headers: {
      // let axios set the boundary automatically, but keeping this is usually OK:
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
